module.exports = new __parcel__URL__("general@2x.dc322db1.png").toString();